import type { PaymentPlatform, ProductMetadata, Server } from './types'

type PackValues = {
  sku: string
  receipt_system_product_id: number
  product_id: number
}

type PlatformValues = {
  annual_default: PackValues
  annual_early_bird: PackValues
  monthly_default: PackValues
  monthly_early_bird: PackValues
}

type PresetPlatforms = {
  ios: PlatformValues
  googleplay_android: PlatformValues
  china_android: PlatformValues
}

type SubscriptionPackSet = {
  annualEarlyBird: ProductMetadata
  annualDefault: ProductMetadata
  monthlyEarlyBird: ProductMetadata
  monthlyDefault: ProductMetadata
}

const PRESETS: Record<Exclude<Server, 'dev'>, PresetPlatforms> = {
  staging: {
    ios: {
      annual_default: {
        sku: 'forest_annual_1',
        receipt_system_product_id: 2,
        product_id: 21,
      },
      annual_early_bird: {
        sku: 'forest_annual_early_bird',
        receipt_system_product_id: 6,
        product_id: 22,
      },
      monthly_default: {
        sku: 'forest_monthly_1',
        receipt_system_product_id: 1,
        product_id: 37,
      },
      monthly_early_bird: {
        sku: 'forest_monthly_early_bird',
        receipt_system_product_id: 5,
        product_id: 38,
      },
    },
    googleplay_android: {
      annual_default: {
        sku: 'forest_plus-annual-1',
        receipt_system_product_id: 4,
        product_id: 23,
      },
      annual_early_bird: {
        sku: 'forest_plus-annual-early-bird',
        receipt_system_product_id: 8,
        product_id: 24,
      },
      monthly_default: {
        sku: 'forest_plus-monthly-1',
        receipt_system_product_id: 3,
        product_id: 39,
      },
      monthly_early_bird: {
        sku: 'forest_plus-monthly-early-bird',
        receipt_system_product_id: 7,
        product_id: 40,
      },
    },
    china_android: {
      annual_default: {
        sku: 'plus_card_annual_1',
        receipt_system_product_id: 23,
        product_id: 46,
      },
      annual_early_bird: {
        sku: 'plus_card_annual_early_bird_1',
        receipt_system_product_id: 24,
        product_id: 47,
      },
      monthly_default: {
        sku: 'plus_card_monthly_1',
        receipt_system_product_id: 21,
        product_id: 44,
      },
      monthly_early_bird: {
        sku: 'plus_card_monthly_early_bird_1',
        receipt_system_product_id: 22,
        product_id: 45,
      },
    },
  },
  global: {
    ios: {
      annual_default: {
        sku: 'forest_annual_1',
        receipt_system_product_id: 2,
        product_id: 15,
      },
      annual_early_bird: {
        sku: 'forest_annual_early_bird',
        receipt_system_product_id: 6,
        product_id: 16,
      },
      monthly_default: {
        sku: 'forest_monthly_1',
        receipt_system_product_id: 1,
        product_id: 27,
      },
      monthly_early_bird: {
        sku: 'forest_monthly_early_bird',
        receipt_system_product_id: 5,
        product_id: 28,
      },
    },
    googleplay_android: {
      annual_default: {
        sku: 'forest_plus-annual-1',
        receipt_system_product_id: 4,
        product_id: 17,
      },
      annual_early_bird: {
        sku: 'forest_plus-annual-early-bird',
        receipt_system_product_id: 8,
        product_id: 18,
      },
      monthly_default: {
        sku: 'forest_plus-monthly-1',
        receipt_system_product_id: 3,
        product_id: 29,
      },
      monthly_early_bird: {
        sku: 'forest_plus-monthly-early-bird',
        receipt_system_product_id: 7,
        product_id: 30,
      },
    },
    china_android: {
      annual_default: {
        sku: 'plus_card_annual_1',
        receipt_system_product_id: 23,
        product_id: 36,
      },
      annual_early_bird: {
        sku: 'plus_card_annual_early_bird_1',
        receipt_system_product_id: 24,
        product_id: 37,
      },
      monthly_default: {
        sku: 'plus_card_monthly_1',
        receipt_system_product_id: 21,
        product_id: 34,
      },
      monthly_early_bird: {
        sku: 'plus_card_monthly_early_bird_1',
        receipt_system_product_id: 22,
        product_id: 35,
      },
    },
  },
  china: {
    ios: {
      annual_default: {
        sku: 'forest_annual_1',
        receipt_system_product_id: 2,
        product_id: 15,
      },
      annual_early_bird: {
        sku: 'forest_annual_early_bird',
        receipt_system_product_id: 6,
        product_id: 16,
      },
      monthly_default: {
        sku: 'forest_monthly_1',
        receipt_system_product_id: 1,
        product_id: 27,
      },
      monthly_early_bird: {
        sku: 'forest_monthly_early_bird',
        receipt_system_product_id: 5,
        product_id: 28,
      },
    },
    googleplay_android: {
      annual_default: {
        sku: 'forest_plus-annual-1',
        receipt_system_product_id: 4,
        product_id: 17,
      },
      annual_early_bird: {
        sku: 'forest_plus-annual-early-bird',
        receipt_system_product_id: 8,
        product_id: 18,
      },
      monthly_default: {
        sku: 'forest_plus-monthly-1',
        receipt_system_product_id: 3,
        product_id: 29,
      },
      monthly_early_bird: {
        sku: 'forest_plus-monthly-early-bird',
        receipt_system_product_id: 7,
        product_id: 30,
      },
    },
    china_android: {
      annual_default: {
        sku: 'plus_card_annual_1',
        receipt_system_product_id: 23,
        product_id: 36,
      },
      annual_early_bird: {
        sku: 'plus_card_annual_early_bird_1',
        receipt_system_product_id: 24,
        product_id: 37,
      },
      monthly_default: {
        sku: 'plus_card_monthly_1',
        receipt_system_product_id: 21,
        product_id: 34,
      },
      monthly_early_bird: {
        sku: 'plus_card_monthly_early_bird_1',
        receipt_system_product_id: 22,
        product_id: 35,
      },
    },
  },
}

function resolvePreset(server: Server): PresetPlatforms {
  if (server === 'dev') return PRESETS.staging
  return PRESETS[server]
}

export type CreateSubscriptionPacksOptions = {
  server: Server
  platform: PaymentPlatform
}

export function createSubscriptionPacks(
  options: CreateSubscriptionPacksOptions,
): SubscriptionPackSet {
  const { server, platform } = options
  const preset = resolvePreset(server)
  const platformValues = preset[platform]

  if (!platformValues) {
    throw new Error(`Missing pack config for platform: ${platform}`)
  }

  const annualEarlyBird = toMetadata(platformValues.annual_early_bird)
  const annualDefault = toMetadata(platformValues.annual_default)
  const monthlyEarlyBird = toMetadata(platformValues.monthly_early_bird)
  const monthlyDefault = toMetadata(platformValues.monthly_default)

  return {
    annualEarlyBird,
    annualDefault,
    monthlyEarlyBird,
    monthlyDefault,
  }
}

function toMetadata(values: PackValues): ProductMetadata {
  return {
    product_type: 'subscription',
    sku: values.sku,
    receipt_system_product_id: values.receipt_system_product_id,
    product_id: values.product_id,
  }
}
